import "./modules/fileupload";

(() => {
    if (document.querySelector("#userChoice")) {
        document.querySelector("#userChoice").addEventListener("change", setValuesSubmission);
    }

    if (document.querySelector("#subjectDiv")) {
        document.getElementById("subjectDiv").style.display = "none";
    }

    document.addEventListener("DOMContentLoaded", () => {
        document.getElementById("suppliedPhoneDiv").style.display = "none";
        document.getElementById("suppliedPhone").disabled = true;
    });

    if (document.querySelector("#userChoiceContact")) {
        document.getElementById("userChoiceContact").addEventListener("change", setSuppliedPhoneVisibility);
    }

    //validation
    const forms = document.querySelectorAll(".needs-validation");

    Array.from(forms).forEach((form) => {
        form.addEventListener(
            "submit",
            async (event) => {
                event.preventDefault();

                if (!form.checkValidity()) {
                    event.stopPropagation();
                } else {
                    document.querySelector("#contactform-button").setAttribute("disabled", "disabled");
                    document.querySelector("#contactform-button .fa-spinner").style.display = "inline-block";
                    if (form.classList.contains("contact-form")) {
                        await setValuesSubmission();
                    }
                    grecaptcha.ready(function () {
                        grecaptcha
                            .execute("6Lfa2P8UAAAAABC6DlDHvyzoW7xhzeCgb5zoPaY4", { action: "submit" })
                            .then(function (token) {
                                form.insertAdjacentHTML(
                                    "afterbegin",
                                    `<input type="hidden" name="g-recaptcha-response" value="${token}" />`,
                                );

                                const data = new FormData();
                                for (const pair of new FormData(form)) {
                                    data.append(pair[0], pair[1]);
                                }

                                fetch(event.target.action, {
                                    method: "POST",
                                    body: data,
                                })
                                    .then((response) => {
                                        if (!response.ok) {
                                            throw new Error(`HTTP error! Status: ${response.status}`);
                                        }
                                        return response.json(); // or response.text() or whatever the server sends
                                    })
                                    .then(() => {
                                        if (form.classList.contains("contact-form")) {
                                            const e = document.getElementById("userChoice");
                                            var optionText = e.options[e.selectedIndex].text;

                                            const dlPushObject = {
                                                event: "contact_form",
                                                data: {
                                                    site: document.querySelector("input[name=site]").value,
                                                    question: optionText,
                                                },
                                            };
                                            dataLayer.push(dlPushObject);

                                            window.location.replace("/about/thank-you");
                                        }
                                    })
                                    .catch((error) => {
                                        console.error(error);
                                        document.querySelector("#error-form").style.display = "block";
                                        document.querySelector("#contactform-button").removeAttribute("disabled");
                                        document.querySelector("#contactform-button .fa-spinner").style.display =
                                            "none";
                                    });
                            });
                    });
                }

                form.classList.add("was-validated");
            },
            false,
        );
    });
})();

function setSuppliedPhoneVisibility(e) {
    if (e.target.value === "3") {
        document.getElementById("suppliedPhone").disabled = false;
        document.getElementById("suppliedPhoneDiv").style.display = "block";
    } else {
        document.getElementById("suppliedPhone").disabled = true;
        document.getElementById("suppliedPhoneDiv").style.display = "none";
    }
}

function setValuesSubmission() {
    document.getElementById("subjectDiv").style.display = "none";

    const val = document.getElementById("userChoice").value;
    document.getElementById("00N5800000CXbPi").value = document.getElementById("userChoice").selectedOptions[0].text;

    switch (val) {
        case "1":
            document.getElementById("00N5800000CXbO0").value = "Account Changes";
            document.getElementById("00N5800000CXbNi").value = "Account (e.g. Login, User management, My info)";
            document.getElementById("00N5800000CXbRi").value = "00GaT000000s4yd";
            document.getElementById("priority").value = "Low";

            break;
        case "2":
            document.getElementById("00N5800000CXbO0").value = "Contract Changes";
            document.getElementById("00N5800000CXbNi").value = "Tariff / Price / Product / Payment scheme - Methods";
            document.getElementById("00N5800000CXbRi").value = "00GaT000000s4yd";
            document.getElementById("priority").value = "Medium";

            break;
        case "3":
            document.getElementById("00N5800000CXbO0").value = "Financial Requests";
            document.getElementById("00N5800000CXbNi").value = "Invoice";
            document.getElementById("00N5800000CXbRi").value = "00GaT000000s4yd";
            document.getElementById("priority").value = "Medium";

            break;
        case "4":
            document.getElementById("00N5800000CXbO0").value = "Contract Changes";
            document.getElementById("00N5800000CXbNi").value = "Tariff / Price / Product / Payment scheme - Methods";
            document.getElementById("00N5800000CXbRi").value = "00GaT000000s4yd";
            document.getElementById("priority").value = "Low";

            break;
        case "5":
            document.getElementById("00N5800000CXbO0").value = "Technical Assistance";
            document.getElementById("00N5800000CXbNi").value = "Configuration";
            document.getElementById("00N5800000CXbRi").value = "00GaT000000s4ye";
            document.getElementById("priority").value = "High";

            break;
        case "6":
            document.getElementById("00N5800000CXbO0").value = "Transactions";
            document.getElementById("00N5800000CXbNi").value = "Status and Errors";
            document.getElementById("00N5800000CXbRi").value = "00GaT000000s4ye";
            document.getElementById("priority").value = "High";

            break;
        case "7":
            document.getElementById("00N5800000CXbO0").value = "Security";
            document.getElementById("00N5800000CXbNi").value = "Data protection";
            document.getElementById("00N5800000CXbRi").value = "00GaT000000s4ye";
            document.getElementById("priority").value = "Low";

            break;
        case "8":
            document.getElementById("00N5800000CXbO0").value = "";
            document.getElementById("00N5800000CXbNi").value = "";
            document.getElementById("00N5800000CXbRi").value = "00GaT000000s4yd";
            document.getElementById("priority").value = "Low";
            document.getElementById("subjectDiv").style.display = "block";

            break;
        case "9":
            document.getElementById("00N5800000CXbO0").value = "Technical Assistance";
            document.getElementById("00N5800000CXbNi").value = "Platform - Release";
            document.getElementById("00N5800000CXbRi").value = "00GaT000000s4ye";
            document.getElementById("priority").value = "Unqualified";

            break;
        default:
            break;
    }

    document.getElementById("contactTheSender").value =
        document.getElementById("userChoiceContact").value === "2" ||
        document.getElementById("userChoiceContact").value === "3"
            ? "Contact the sender"
            : "";
}
